export default __webpack_public_path__ + "static/media/undraw_undraw_posts_givd_-1-_5vi7.7a434911.svg";